export const CUE_LIST_GRID_TEMPLATE = "52px minmax(220px, 1.3fr) minmax(220px, 1.2fr) 110px 110px 110px 170px 48px 96px";
